var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 2.79171C10.4918 1.58337 8.8335 0.833374 6.99183 0.833374C3.3085 0.833374 0.333496 3.81671 0.333496 7.50004C0.333496 11.1834 3.3085 14.1667 6.99183 14.1667C10.1002 14.1667 12.6918 12.0417 13.4335 9.16671H12.4168C11.8089 11.6667 9.17516 13.3334 7.00016 13.3334C3.89225 13.3334 1.16683 10.2584 1.16683 7.50004C1.16683 4.74171 3.47559 1.66671 7.00016 1.66671C8.3835 1.66671 9.72559 2.08337 11.1668 3.33337L9.30892 5.00004L13.8923 5.83337L13.4756 1.25004L11.7002 2.79171Z",
    fill: "#B58C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.02b08f319a102a6b8f3f559548af1052.svg";
export { ForwardRef as ReactComponent };